<template>
  <div>
    <v-navigation-drawer
      v-model="info.activated"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="info.activated"
      hide-overlay
      class="z-index--100">
      <div class="ma-3">
        <div class="d-flex">
          <v-btn
            dark
            fab
            x-small
            outlined
            color="primary"
            class="mr-3"
            @click="info.activated=false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div class="subtitle-1 primary--text">
            Información de {{ info.item }}
          </div>
        </div>
        <div>
          <div
            v-if="info.loading"
            class="d-flex justify-center align-center">
            <v-progress-circular
              indeterminate
              color="primary"
            />
          </div>
          <div
            v-else>
            <v-list
              v-if="info.data.recipes && info.data.recipes.length"
              dense
              subheader>
              <v-subheader>Uso en recetas:</v-subheader>
              <v-list-item
                v-for="recipe in info.data.recipes"
                :key="recipe.id"
                three-line
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ recipe.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Cantidad usada en esta receta:
                    {{ recipe.ingredient ? recipe.ingredient.quantity : '' }}
                    {{ recipe.ingredient ? recipe.ingredient.unit.name : '' }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Ventas semanales: {{ recipe.weeklySale }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider/>
            </v-list>
            <v-list
              v-if="info.data.movements && info.data.movements.length"
              dense
              subheader>
              <v-subheader>Movimientos de inventario:</v-subheader>
              <v-list-item
                v-for="movement in info.data.movements"
                :key="movement.id"
                three-line
              >
                <v-list-item-content>
                  <v-list-item-subtitle>
                    Fecha: {{ convertToDateString(movement.createdAt) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <div>
                      Última cantidad registrada: {{ movement.quantity }}
                    </div>
                    <div>
                      Cantidad previa: {{ movement.previousValue }}
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
      <div class="d-flex justify-end align-center">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca productos por nombre"
          solo
          hide-details
          rounded
          flat
          dense/>
        <v-tooltip left>
          <template
            v-slot:activator="{ on }">
            <v-btn
              :href="exportRoute"
              v-on="on"
              target="_blank"
              dark
              fab
              x-small
              depressed
              color="secondary"
              class="mx-3"
            >
              <v-icon color="white">mdi-application-export</v-icon>
            </v-btn>
          </template>
          <span>Exportar inventario</span>
        </v-tooltip>
        <!-- <v-btn
          v-if="!['stockmanager', 'chef'].includes($is())"
          class="mr-3"
          color="secondary"
          small
          rounded
          depressed
          @click="openResetTeoricInventoriDialog"
        >
          Igualar inventarios
        </v-btn> -->
      </div>
    </div>

    <div class="px-3 pt-3">
      <v-skeleton-loader v-if="overlay" type="button" />
      <v-btn-toggle
        v-else
        v-model="favorites"
        rounded
        mandatory>
        <v-btn
          small
          class="white--text"
          :outlined="favorites !== 0"
          color="primary">
          Todos
        </v-btn>
        <v-btn
          class="white--text"
          small
          :outlined="favorites !== 1"
          color="primary">
          Favoritos
        </v-btn>
      </v-btn-toggle>
    </div>

    <v-flex xs12>
      <v-skeleton-loader v-show="overlay" type="table" />
      <v-form v-show="!overlay" ref="inventory" v-model="isValid">
        <v-data-table
          :loading-text="table.title"
          :server-items-length="table.total"
          :headers="headers"
          :items="table.data"
          :options="table.options"
          :sort-by="sortAttrName"
          @update:options="updateTable"
          @update:sort-by="sortByTable"
          @update:sort-desc="sortDescTable"
          :footer-props="table.footer"
          class="elevation-1 d-print">
          <template
            v-slot:top>
            <div class="px-3">
              <v-row>
                <v-col md="3">
                  <v-select
                    v-model="category"
                    :items="categories"
                    item-text="name"
                    item-value="id"
                    label="Departamento"
                    hide-details
                    dense
                    @change="onChangeCategory"
                  />
                </v-col>
              </v-row>
            </div>
          </template>
          <template v-slot:item.favorite="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  :color="item.favorite ? 'warning' : 'grey'"
                  v-on="on"
                  @click="markAsFavorite(item)">
                  {{ item.favorite ? 'mdi-star' : 'mdi-star-outline' }}
                </v-icon>
              </template>
              <span>
                {{ item.favorite ? 'Desmarcar como favorito' : 'Marcar como favorito' }}
              </span>
            </v-tooltip>
          </template>
          <template v-slot:item.name="{ item }">
            <a
              v-if="!['stockmanager', 'chef'].includes($is())"
              href="#"
              @click.prevent="openInfo(item)">
              {{ item.name }}
            </a>
            <div
              v-else>
              {{ item.name }}
            </div>
            <div v-if="item.choice && item.choice.description" class="caption grey--text text-uppercase">
              {{ item.choice.description }}
            </div>
            <div
              v-if="item.choice && item.choice.brand"
              class="caption grey--text">
              {{ item.choice.brand }}
            </div>
          </template>
          <template
            v-slot:item.quantityAvailable="{ item }"
            v-if="['stockmanager', 'manager', 'chef', 'buyer'].includes($is())">
            <div>
              <div v-if="item.loading">
                <v-progress-circular
                  indeterminate
                  color="primary"
                />
              </div>
              <div class="d-flex" style="max-width:250px" v-else>
                <div style="width:100px">
                  <v-text-field
                    v-if="item.edit"
                    v-model.number="item.quantityAvailable"
                    outlined
                    rounded
                    hide-details
                    dense
                    :rules="rules.numberValid"
                    @blur="updateInventory(item)"
                    @keydown.enter="updateInventory(item)" />
                  <div v-else>
                    <div v-if="item.updatedBy">
                      {{ item.quantityAvailable }} <span class="pl-2 caption grey--text"> {{ item.unit.name }}</span>
                    </div>
                    <div v-else>
                      Sin captura
                    </div>
                  </div>
                </div>
                <div>
                  <v-btn
                    v-if="item.edit"
                    icon
                    color="primary"
                    x-small
                    depressed
                    @click="item.edit = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    icon
                    color="primary"
                    x-small
                    depressed
                    @click="openInput(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </template>
          <!-- <template v-slot:item.quantityCalculated="{ item }">
            <div class="text-right">
              <span>
                {{ item.quantityCalculated | toFixNumber(3) | numberWithComma }}
              </span>
              <span class="caption grey--text">
                {{ item.unit.code }}
              </span>
            </div>
          </template>
          <template v-slot:item.stockQuantity="{ item }">
            <div class="text-right">
              <span v-if="item.choice">
                {{ (item.stockQuantity * item.choice.contentQuantity) | toFixNumber(0) | numberWithComma }}
              </span>
              <span v-else>
                {{ item.stockQuantity | toFixNumber(0) | numberWithComma }}
              </span>
              <span class="caption grey--text">
                {{ item.unit.code }}
              </span>
            </div>
          </template>
          <template v-slot:item.consumption="{ item }">
            <div class="text-right">
              <span>
                {{ item.consumption | toFixNumber(2) | numberWithComma }}
              </span>
              <span class="caption grey--text">
                {{ item.unit.code }}
              </span>
            </div>
          </template>
          <template v-slot:item.difference="{ item }">
            <div class="text-right">
              <span>
                {{ item.difference | toFixNumber(3) | numberWithComma }}
              </span>
              <span class="caption grey--text">
                {{ item.unit.code }}
              </span>
            </div>
          </template> -->
          <template
            v-slot:item.purchaseOrder="{ item }"
            v-if="['stockmanager', 'manager', 'chef'].includes($is())">
            <div class="d-flex" style="max-width:250px">
              <div style="width:100px">
                <v-text-field
                  v-model.number="item.purchaseOrder"
                  type="number"
                  outlined
                  rounded
                  hide-details
                  dense />
                <!-- :rules="rules.numberValid" -->
              </div>
              <div class="d-flex align-center pl-2 caption grey--text">
                {{ ((item.choice || {}).contentUnit || {}).code || '' }}
              </div>
            </div>
          </template>
          <template v-slot:item.category="{ item }">
            <div v-if="item.product && item.product.category">
              {{ item.product.category.name }}
            </div>
            <div v-else>
              SUBRECETA
            </div>
          </template>
          <template v-slot:item.warehouseLocation="{ item }">
            <div class="d-flex justify-space-between">
              <div>
                {{ item.warehouseLocation || '-' }}
              </div>
              <div>
                <AddWarehouseLocation
                  :input="item"
                  @update="updateInput"/>
              </div>
            </div>
          </template>
          <template v-slot:item.updatedBy="{ item }">
            <div v-if="item.updatedBy">
              <div>
                {{ (item.updatedBy || {}).email }}
              </div>
              <div>
                {{ item.updatedAt | toDateTime }}
              </div>
            </div>
            <div v-else>
              <div>
                -
              </div>
            </div>
          </template>
        </v-data-table>
      </v-form>
    </v-flex>

    <v-dialog
      @keydown.esc="resetDialog=false"
      v-model="resetDialog"
      max-width="500"
    >
      <v-card
        color="blue-grey"
        dark
      >
        <v-card-title>
          Igualar inventarios
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col md="1">
              <v-icon>mdi-alert</v-icon>
            </v-col>
            <v-col>
              <div>
                Al aceptar igualar tus inventarios, los valores de tu inventario teórico se sobreescribirán con los valores de tu inventario físico.
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            text
           @click="resetDialog = false">
            Cancelar
          </v-btn>
          <v-btn
            color="blue-grey darken-4"
           @click="resetTeoricInventory">
            De acuerdo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import AddWarehouseLocation from '@/components/modals/AddWarehouseLocation'

export default {
  name: 'CaptureInventory',
  components: {
    AddWarehouseLocation
  },
  data () {
    return {
      isValid: false,
      resetDialog: false,
      overlay: false,
      section: this.$i18n.t('inventory.captureTitle'),
      sortAttrName: 'name',
      attrNamesSorteable: ['name', 'choice.provider.name', 'area.name', 'difference'],
      loadedData: null,
      table: {
        title: this.$i18n.t('inventory.loading'),
        loading: true,
        headers: [
          { value: 'favorite', sortable: false },
          { text: this.$i18n.t('inventory.headers.name'), value: 'name', sortable: true },
          { text: this.$i18n.t('inventory.headers.departament'), value: 'category' },
          { text: this.$i18n.t(`inventory.headers.quantityAvailable.${this.$is()}`), value: 'quantityAvailable', sortable: false },
          { text: this.$i18n.t(`inventory.headers.warehouseLocation`), value: 'warehouseLocation' },
          { text: this.$i18n.t(`inventory.headers.lastUpdate`), value: 'updatedBy' }
        ],
        data: [],
        total: 0,
        options: {
          itemsPerPage: 100,
          page: 1
        },
        footer: {
          'items-per-page-options': [50, 100, 200]
        }
      },
      info: {
        activated: false,
        loading: false,
        item: null,
        data: {
          recipes: null,
          movements: null
        }
      },
      categories: [],
      category: null,
      search: '',
      errors: [],
      rules: {
        numberValid: [
          v => (v !== '' && !isNaN(v * 1)) || this.$t('validations.numberValid')
        ]
      },
      favorites: 0
    }
  },
  computed: {
    exportRoute () {
      return `${process.env.VUE_APP_API_URL}/v1/inputs/export?restaurant=${this.$store.state.currentRestaurant.data._id}`
    },
    headers () {
      let allowedHeaders = [...this.table.headers]
      if (['stockmanager', 'chef'].includes(this.$is())) {
        const restrictedHeaders = ['reorder', 'quantityCalculated', 'difference', 'consumption']
        allowedHeaders = allowedHeaders.filter((allowedHeader) => {
          return !restrictedHeaders.includes(allowedHeader.value)
        })
      }
      // if (this.$is() === 'manager' || this.$is() === 'buyer') {
      //   const restrictedHeaders = ['stockArea', 'category']
      //   restrictedHeaders.forEach((restrictedHeader) => {
      //     const index = allowedHeaders.findIndex(header => header.value === restrictedHeader)
      //     allowedHeaders.splice(index, 1)
      //   })
      // }
      return allowedHeaders
    }
  },
  watch: {
    'search': async function (val) {
      const params = {
        limit: this.table.options.itemsPerPage,
        area: this.$store.state.area.id,
        skip: (this.table.options.itemsPerPage * (this.table.page - 1)),
        sort: 'name'
      }
      if (val.length >= 3) {
        try {
          params.name = new RegExp(val, 'i')
          params.warehouseLocation = new RegExp(val, 'i')
          let content = this.loadedData
          if (this.category) {
            params['product.category'] = this.category
            content = content.filter(x => {
              if (x.product && x.product.category) {
                return x.product.category.uuid === params['product.category']
              }
              return false
            })
          }
          content = content.filter(x => params.name.test(x.name) || params.warehouseLocation.test(x.warehouseLocation))
          this.table.data = content
          this.table.total = content.length
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      } else {
        this.filterByCategory(this.category)
      }
    },
    favorites: async function (val) {
      this.search = ''
      if (this.loadedData.length) {
        this.filterByCategory(this.category)
      }
    }
  },
  async mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
    await this.getCategories()
    if (this.$store.state.area) {
      await this.load({
        limit: -1,
        skip: 0,
        sort: 'name',
        area: this.$store.state.area.id
      })
    }
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.info.activated = false
    },
    updateInput (input) {
      const index = this.loadedData.findIndex(item => item._id === input._id)
      const copyData = [...this.loadedData]
      copyData[index].favorite = input.favorite
      copyData[index].warehouseLocation = input.warehouseLocation
      copyData[index].updatedBy = input.updatedBy
      this.loadedData = copyData
      this.table.data = this.loadedData
      this.filterByCategory(this.category)
    },
    updateInventory: _.debounce(async function (item) {
      if (typeof item.quantityAvailable === 'number') {
        item.loading = true
        const payload = { quantityAvailable: (item.quantityAvailable || 0) }
        try {
          const input = await this.$api.put(`/v1/inputs/${item._id}/set`, payload)
          this.$toasted.show('El inventario se actualizó', { duration: 1500 })
          this.updateInput(input)
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        item.loading = false
      }
    }, 300),
    markAsFavorite: async function (item) {
      this.overlay = true
      const payload = { favorite: !item.favorite }
      try {
        const input = await this.$api.put(`/v1/inputs/${item._id}/set`, payload)
        this.updateInput(input)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    showFavoriteData () {
      this.table.data = this.loadedData.filter(item => item.favorite)
      this.table.total = this.table.data.length
    },
    setError (type, item, error) {
      if (error) {
        const index = this.errors.findIndex(i => i.uuid === item.uuid)
        if (index < 0) {
          this.errors.push(item)
        }
      } else {
        const index = this.errors.findIndex(i => i.uuid === item.uuid)
        if (index >= 0) {
          this.errors.splice(index, 1)
        }
      }
    },
    convertToDateString (date) {
      const d = new Date(date)
      return d.toLocaleDateString()
    },
    async openInfo (item) {
      this.info.loading = true
      try {
        const data = await this.$api.get('/v1/inputs/info', { product: item.product.id })
        this.info.item = item.name
        this.info.data = data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.info.activated = true
      this.info.loading = false
    },
    print () {
      window.print()
    },
    updateTable: async function (data) {
      const { sortBy, sortDesc } = data
      const start = data.itemsPerPage * (data.page - 1)
      const end = data.itemsPerPage * data.page
      const sortParam = (sortDesc > 0 ? '' : '-') + sortBy
      const filteredData = this.favorites === 1
        ? this.loadedData.filter(item => item.favorite)
        : this.loadedData
      this.table.data = _.sortBy(filteredData, sortParam).slice(start, end)
    },
    async load (params = null) {
      params = params || {
        area: this.$store.state.area.id,
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: 'name',
        status: 'attached'
      }

      params.limit = 1000
      this.overlay = true
      try {
        const response = await this.$api.get('/v1/inputs', params)

        this.loadedData = response.data.map(product => Object.assign(
          product,
          {
            edit: false,
            loading: false,
            difference: this.calculateDifference(product),
            quantityAvailable: (['chef'].includes(this.$is())) ? '' : product.quantityAvailable
          }
        ))
        this.table.data = this.loadedData

        await this.updateTable({
          sortBy: 'name',
          sortDesc: 1,
          itemsPerPage: this.table.options.itemsPerPage,
          page: this.table.options.page
        })
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async update () {
      this.$refs.inventory.validate()
      this.loadedData.forEach(item => {
        if (item.quantityAvailable === '') {
          this.setError('quantityAvailable', item, true)
        }
      })
      if (!this.isValid || this.errors.length) {
        const errors = this.errors.map(error => `</br>${error.name}`)
        const message = `Existen datos vacios en los productos: ${errors}`
        this.$toasted.show(
          message,
          {
            action: {
              text: 'Cerrar',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            }
          }
        )
      } else {
        this.overlay = true
        const payload = {
          items: this.loadedData.map(item => ({
            quantityCalculated: item.quantityCalculated,
            quantity: item.quantityAvailable,
            id: item.uuid,
            reorder: item.reorder
          }))
        }
        try {
          await this.$api.put('/v1/inputs/update', payload)
          this.$toasted.show(
            'Los productos se actualizaron correctamente',
            {
              type: 'success',
              action: {
                class: 'action-black',
                text: 'Cerrar',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                }
              }
            })
          this.$refs.inventory.reset()
          await this.load({
            limit: -1,
            skip: 0,
            sort: 'name',
            area: this.$store.state.area.id,
            forceReload: true
          })
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.table.options.page = 1
        this.category = null
        this.search = ''
        this.overlay = false
      }
    },
    calculateDifference (product) {
      return product.quantityAvailable - product.quantityCalculated
    },
    async getCategories () {
      const { data } = await this.$api.get(`/v1/categories`, { sort: 'name' })
      data.unshift({ id: null, name: 'Todas' })
      this.categories = data
    },
    onChangeCategory (category) {
      this.search = ''
      this.filterByCategory(category)
    },
    filterByCategory (category) {
      this.category = category
      const params = {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.page - 1)),
        sort: 'name',
        area: this.$store.state.area.id,
        subrecipe: false
      }
      this.overlay = true
      if (category) {
        params['product.category'] = category
        const content = this.loadedData.filter(x => {
          if (x.product && x.product.category) {
            return this.favorites === 1
              ? x.product.category.id === params['product.category'] && x.favorite
              : x.product.category.id === params['product.category']
          }
          return false
        })
        this.table.data = content
        this.table.total = content.length
      } else {
        if (this.favorites === 1) {
          this.showFavoriteData()
        } else {
          this.table.data = this.loadedData
          this.table.total = this.loadedData.length
        }
      }
      this.overlay = false
    },
    openResetTeoricInventoriDialog () {
      this.resetDialog = true
    },
    async resetTeoricInventory () {
      this.resetDialog = false
      this.overlay = true
      try {
        await this.$api.put('/v1/inputs/bulk-reset')
        this.$toasted.show('El inventario se actualizó correctamente', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      await this.load({
        limit: -1,
        skip: 0,
        sort: 'name',
        area: this.$store.state.area.id,
        forceReload: true
      })
      this.overlay = false
    },
    async sortDescTable (data) {
      if (!data) return
      this.loadedData = this.loadedData.reverse()
      await this.updateTable({
        sortBy: this.sortAttrName,
        sortDesc: -1,
        itemsPerPage: this.table.options.itemsPerPage,
        page: this.table.options.page
      })
    },
    async sortByTable (data) {
      if (!data && !this.attrNamesSorteable.includes(data)) return
      const floatColumns = [ 'difference' ]
      this.loadedData = this.loadedData.sort((a, b) => {
        a = _.get(a, data)
        b = _.get(b, data)
        if (floatColumns.includes(data)) {
          a = parseFloat(a)
          b = parseFloat(b)
        }
        if (a > b) return 1
        if (a < b) return -1
        return 0
      })
      this.sortAttrName = data
      await this.updateTable({
        sortBy: data,
        sortDesc: 1,
        itemsPerPage: this.table.options.itemsPerPage,
        page: this.table.options.page,
        area: this.$store.state.area.id
      })
    },
    openInput (item) {
      this.loadedData.forEach(product => { product.edit = false })
      item.edit = true
    }
  }
}
</script>

<style lang="scss">
.action-black {
  color: black !important;
}
.z-index--100 {
  z-index: 100 !important;
}
</style>
